import { render, staticRenderFns } from "./NewTextract.vue?vue&type=template&id=5b26f5a8&scoped=true&"
import script from "./NewTextract.vue?vue&type=script&lang=js&"
export * from "./NewTextract.vue?vue&type=script&lang=js&"
import style0 from "./NewTextract.vue?vue&type=style&index=0&id=5b26f5a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b26f5a8",
  null
  
)

export default component.exports